// extracted by mini-css-extract-plugin
export default {"container":"HistoryViewer-module__container--b3b4","header":"HistoryViewer-module__header--076e","description":"HistoryViewer-module__description--65f1"};